import { Flex } from '@chakra-ui/react';

import { ArrowLeft, ArrowRight } from 'assets/assetsV1/iconComponents';

import { Button } from 'uiToolkitV1/Button';

interface SectionFooterProps {
  backText?: React.ReactNode;
  continueText?: React.ReactNode;
  onBack?: () => any;
  onContinue?: () => any;
  rightContent?: React.ReactNode;
  isContinueDisabled?: boolean;
}

export const SectionFooter = ({
  backText,
  continueText,
  onBack,
  onContinue,
  rightContent = null,
  isContinueDisabled = false,
}: SectionFooterProps) => {
  const hasBackButton = !!backText && !!onBack;
  const hasContinueButton = !!continueText && !!onContinue;

  return (
    <Flex p={4} alignItems="center" bg="rgba(245, 247, 249, 0.9)" boxShadow="0px -1px 0px #CFD7DF">
      {hasBackButton && (
        <Button variant="tertiary" StartIcon={() => <ArrowLeft boxSize="24px" />} onClick={onBack}>
          {backText}
        </Button>
      )}
      {/* for the special case and more control for what to render on right */}
      {rightContent}
      {hasContinueButton && (
        <Button
          ml="auto"
          EndIcon={() => <ArrowRight boxSize="24px" color="#fff" />}
          onClick={onContinue}
          isDisabled={isContinueDisabled}
        >
          {continueText}
        </Button>
      )}
    </Flex>
  );
};
